<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Standard Admission Fee
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined
                        @change="getStd();getAdmissionFee();" persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" multiple dense rounded required v-model="sel_std_data"
                        item-value="std_id" :items="std_div_list" item-text="std" label="Select Standard" outlined
                        @change="getDiv" persistent-hint hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined rounded v-model="amount" type="number" persistent-hint
                        hint="Please Select Admission Fees" label="Admission Fee"></v-text-field>
                </v-col>
                <v-col sm="2" v-if="sel_ay_data && sel_std_data && amount">
                    <v-btn class="mt-6 button" @click="addAdmissionFee()" :loading="fetch_loader">Add Admission
                        Fee</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="admission_fee_list!=''">
            <v-data-table v-if="admission_fee_list!=''" :headers="headers" :items="admission_fee_list" dense
                class="elevation-1 mytable" :search="search">
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <strong>
                                    Edit Standard Admission Fee
                                </strong>
                            </v-toolbar-title>
                        </v-toolbar>
                        <!-- {{editedItem}} -->
                        <v-row justify="center" dense v-if="editedItem">
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field disabled readonly color="#0F2027" dense rounded required
                                    v-model="editedItem.academic_year" outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field disabled readonly color="#0F2027" multiple dense rounded required
                                    v-model="editedItem.standard" outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field dense outlined rounded v-model="editedItem.amount" type="number"
                                    persistent-hint label="Admission Fee"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" class="pt-none mt-none">
                                <v-checkbox class="pt-none mt-none" dense v-model="editedItem.isactive" color="success"
                                    label="Active"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="dialog = false">Cancel</v-btn>
                            <v-btn class="button" @click="save(editedItem)">Save</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                fetch_loader: false,
                com_sub_loader: false,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                overlay: false,
                selected: [],
                snackbar: false,
                crs_id: null,
                editedIndex: -1,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                singleSelect: false,
                selectedTasks: [],
                ay_std_div_list: null,
                sel_ay_data: null,
                show_tt: false,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                admission_fee_list: [],
                editedItem: null,
                amount: null,
                dialog: false,
                headers: [
                     {
                        text: "Academic Year",
                        align: "left",
                        sortable: false,
                        value: "academic_year",
                    },
                    {
                        text: "Standard",
                        align: "left",
                        sortable: false,
                        value: "standard",
                    },
                    {
                        text: "Amount",
                        align: "left",
                        sortable: false,
                        value: "amount",
                    },
                    {
                        text: "Active",
                        align: "left",
                        sortable: true,
                        value: "isactive",
                    },
                    {
                        text: "Actions",
                        value: "action",
                        sortable: false,
                    },
                ],
            };
        },
        methods: {
            save(editedItem) {
                 const data = {
                    amount: editedItem.amount,
                    isactive: editedItem.isactive,
                    af_id: editedItem.af_id
                };
                 axios
                    .post("/AccountingAndFees/editAdmissionFee", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Admission Fee Edited Successfully..."); // show snackbar on success
                            this.getAdmissionFee();
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },
            editItem(item) {
                this.editedIndex = this.admission_fee_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            getAdmissionFee() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                axios
                    .post("/AccountingAndFees/getAdmissionFee", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.admission_fee_list = res.data.admission_fee_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            addAdmissionFee() {
                this.fetch_loader = true;
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    amount: this.amount,
                    standard: this.sel_std_data,
                };
                axios
                    .post("/AccountingAndFees/saveAdmissionFee", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Admission Fee Added Successfully..."); // show snackbar on success
                            this.getAdmissionFee();
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                        this.amount = null;
                        this.sel_std_data = null;
                        this.sel_ay_data = null;
                    });
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        // this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
